import * as React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { useTranslation } from "react-i18next";

function FeaturedProduct(props) {
  const { t } = useTranslation();
  const { product } = props;

  return (
    // <Grid item xs={12} md={6} sx={{ display: "flex" }} key={post.title}>
    //   <CardActionArea component="a" href="#" sx={{ width: "100%" }}>
    //     <Card sx={{ display: "flex", width: "100%", height: "100%" }}>
    //       <CardContent sx={{ flex: 1 }}>
    //         <Typography component="h2" variant="h5">
    //           {post.title}
    //         </Typography>
    //         <Typography variant="subtitle1" color="text.secondary">
    //           {post.date}
    //         </Typography>
    //         <Typography variant="subtitle1" paragraph>
    //           {post.description}
    //         </Typography>
    //         <Typography variant="subtitle1" color="primary">
    //           Continue reading...
    //         </Typography>
    //       </CardContent>
    //       <CardMedia
    //         component="img"
    //         sx={{ width: 160, display: { xs: "none", sm: "block" } }}
    //         image={post.image}
    //         alt={post.imageLabel}
    //       />
    //     </Card>
    //   </CardActionArea>
    // </Grid>
    <Grid item xs={12} md={6} sx={{ display: "flex" }} key={product.title}>
      <CardActionArea
        component="a"
        href={`/product/${product.id}`}
        sx={{ width: "100%" }}
      >
        <Card
          sx={{
            display: "flex",
            flexDirection: "column", // 👈 stack image and content vertically
            width: "100%",
          }}
        >
          {product.image_url && (
            <CardMedia
              component="img"
              image={product.image_url}
              alt={t("productImage")}
              sx={{
                width: "100%",
                height: 300,
                objectFit: "cover",
                backgroundColor: "#f5f5f5",
              }}
            />
          )}

          <CardContent
            sx={{
              "& .MuiTypography-root": {
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },
            }}
          >
            <Typography variant="h5">{product.title}</Typography>
            <Typography variant="subtitle1" color="text.secondary">
              {product.date_created}
            </Typography>
            <Typography variant="subtitle1" paragraph>
              {product.description}
            </Typography>
            <Typography variant="subtitle1" color="primary">
              {t("details")}
            </Typography>
          </CardContent>
        </Card>
      </CardActionArea>
    </Grid>
  );
}

FeaturedProduct.propTypes = {
  product: PropTypes.shape({
    date_created: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
    image_path: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default FeaturedProduct;
